import TimeFilter from "./TimeFilter";

interface SectionHeaderProps {
  title: string;
  subtitle: string;
  filters?: string[];
  activeFilter?: string;
  onFilterChange: (filter: string) => void;
}

export default function SectionHeader({
  title,
  subtitle,
  filters,
  activeFilter,
  onFilterChange,
}: SectionHeaderProps) {
  return (
    <header className="sectionHeader">
      <div>
        <h1 className="sectionTitle">{title}</h1>
        <p className="sectionSubtitle">{subtitle}</p>
      </div>
      {filters?.length && activeFilter ? (
        <TimeFilter
          filters={filters}
          activeFilter={activeFilter}
          onFilterChange={onFilterChange}
        />
      ) : null}
    </header>
  );
}
